<script lang="ts">
  import { page } from '$app/state';
  import { storeMobileMenu } from '$lib/js/stores';
  import { t } from 'svelte-i18n-lingui';
  import type { Category } from "$lib/js/elasticsearch/types";
	import { getUniverseInfo } from '$lib/js/helpers'
	import { getContextScope } from '$lib/js/helpers/i18n'
  import { onNavigate } from '$app/navigation'

  /* Menu */
	const { firstLevel, secondLevel, thirdLevel } = page.data.menu_levels
	const scope = getContextScope()

  let firstActive = $state(firstLevel[0].id)
  let secondActive = $state(secondLevel[0].id)

  let parentFirstActive = {}
  let parentSecondActive = $state({})

  let displayFirst = 'visible'
  let displaySecond = $state('not-visible')
  let displayThird = $state('not-visible')

  function closeMenu() {
    $storeMobileMenu = false
  }

  function optionSecondSelected(option: Category) {
    parentSecondActive = option
    secondActive = option.id
    displaySecond = 'not-visible'
    displayThird = 'visible'
  }

  function backToSecond(option: Category) {
    secondActive = option.id
    displaySecond = 'visible'
    displayThird = 'not-visible'
  }

  let universe_info = getUniverseInfo(
    page.data?.universes_menu?.universes,
    page.data?.category?.url_path?.split("/")[1]
  )

  if(universe_info) {
    firstActive = parseInt(universe_info.cat_id)
    displayFirst = 'not-visible'
    displaySecond = 'visible'
  }

  onNavigate(() => {
    closeMenu()
  })
</script>

{#if firstLevel && firstLevel.length > 0}
  <div class="tab-cats__inner tab-cats-universe">
    <div class="tab-cats__secondary {displaySecond}">
      <a
        class="parent"
        href="/{scope}/u/{universe_info.name}"
      >{$t`Go to bixoto`} {universe_info.name} <span></span></a>

      {#each secondLevel as option}
        {#if option.parent_id === firstActive}
          <button
            class="link"
            onclick={() => optionSecondSelected(option)}
          >{option.name}<span></span></button>
        {/if}
      {/each}
    </div>

    <div class="tab-cats__tertiary {displayThird}">
      <button class="tab-cats__header" onclick={() => backToSecond(parentFirstActive)}>
        <h2><span></span> {$t`Subcategories`}</h2>
      </button>

      <a
        class="parent"
        href="/{scope}/{parentSecondActive.url_path}"
      >{$t`View ${parentSecondActive.name}`} <span></span></a>

      {#each thirdLevel as option}
        {#if option.parent_id === secondActive}
          <a
            class="link"
            href="/{scope}/{option.url_path}"
          >{option.name} <span></span></a>
        {/if}
      {/each}
    </div>
  </div>
{/if}

<style lang="scss">
  .tab-cats {
    &__inner {
      height: calc(100dvh - 96px);
      overflow-y: scroll;
    }

    &__primary,
    &__secondary,
    &__tertiary {
      display: flex;
      flex-direction: column;
      width: 100%;

      a.parent {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 20px 20px;
        font-weight: 700;
        font-size: 16px;
        border-bottom: 1px solid var(--main);

        span {
          &::before,
          &::after {
            border-color: var(--main);
          }
        }
      }

      .link {
        position: relative;
        text-align: left;
        color: black;
        padding: 20px 20px;
        border-bottom: 1px solid var(--grey);
        display: flex;
        align-items: center;
        justify-content: space-between;

        &:hover {
          background:var(--grey);
        }
      }

      button,
      a {
        span {
          position: relative;
          display: inline-block;
          width: 15px;

          &::before,
          &::after {
            position: absolute;
            content: "";
            display: block;
            border-bottom: 1px solid var(--grey--b);
            width: 10px;
          }

          &::before {
            top: -4px;
            transform: rotate(45deg);
          }

          &::after {
            top: 3px;
            transform: rotate(-45deg);
          }
        }
      }

      &.not-visible {
        pointer-events: none;
        position: absolute;
        visibility: hidden;
        opacity: 0;
        right: 100%;
      }

      &.visible {
        transition: all linear 0.3s;
        visibility: visible;
        opacity: 1;
      }
    }

    &__header {
      text-align: left;

      h2 {
        display: flex;
        align-items: center;
        padding: 15px;
        margin: 0;
        font-size: 14px;
        border-bottom: 1px solid var(--grey);

        span {
          transform: rotate(180deg);
          margin-right: 15px;

          &::before,
          &::after {
            border-color: black;
            border-width: 2px;
          }

          &::after {
            top: 2px;
          }
        }
      }
    }
  }
</style>
